import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getEgreso } from "../../../redux/actions";
import Button from "../../../components/button";

const sectionClass =
  "bg-white rounded-[8px] border border-[#61ABCF] divide-y divide-[#61ABCF]";

const rowClass = "grid grid-cols-2 gap-5 px-4 py-2";

const labelClass = "text-sm/6 font-medium text-gray-900";

const valueClass = "mt-1 sm:mt-0 text-sm/6 text-gray-700";

const titleClass = "text-sm/6 font-bold text-[#036395] font-inter";

function InfoRow({ label, value, valueClassName = "" }) {
  return (
    <div className={rowClass}>
      <dt className={labelClass}>{label}</dt>
      <dd className={`${valueClass} ${valueClassName}`}>{value}</dd>
    </div>
  );
}

function SectionTitle({ children }) {
  return (
    <div className={rowClass}>
      <dt className={titleClass}>{children}</dt>
      <dd />
    </div>
  );
}

function VerEgresoComponent({ idSecuestro, closeVerEgreso }) {
  const dispatch = useDispatch();

  const [egreso, setEgreso] = useState({});

  useEffect(() => {
    const fetchEgreso = async () => {
      const resp = await dispatch(getEgreso(idSecuestro));
      setEgreso(resp);
    };

    fetchEgreso();
  }, [dispatch, idSecuestro]);

  const {
    bPago,
    domicilio,
    dni,
    fecha_hora,
    firma,
    licencia,
    nombreCompleto,
    obs,
    tarjetaVerde,
    User,
  } = egreso;

  const date = fecha_hora ? new Date(fecha_hora) : null;

  const options = {
    timeZone: "America/Argentina/Buenos_Aires",
    hour12: false,
  };

  const env = process.env.REACT_APP_ENVIRONMENT || "development";

  const remoteDir =
    env === "production"
      ? "images/corralon/production/firmas_secuestros"
      : "images/corralon/stage/firmas_secuestros";

  const urlFirma = `https://staticcontent.sannicolasciudad.gob.ar/${remoteDir}/${firma}`;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
      onClick={closeVerEgreso}
    >
      <div
        className="flex flex-col gap-4 rounded-lg border bg-[#F5FAFF] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`relative ${sectionClass}`}>
          <button
            onClick={closeVerEgreso}
            className="absolute top-1 right-1 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>

          <SectionTitle>EGRESO</SectionTitle>

          <InfoRow
            label="Apellido y nombres"
            value={nombreCompleto || "-"}
          />

          <InfoRow
            label="DNI"
            value={dni || "-"}
          />

          <InfoRow
            label="Domicilio"
            value={domicilio || "-"}
          />

          <InfoRow
            label="Fecha y Hora"
            value={
              date
                ? date.toLocaleString("es-AR", options)
                : "-"
            }
          />

          <InfoRow
            label="Licencia"
            value={licencia || "-"}
          />

          <InfoRow
            label="Tarjeta verde"
            value={tarjetaVerde || "-"}
          />

          <InfoRow
            label="Boleta de pago"
            value={bPago || "-"}
          />

          <InfoRow
            label="Observaciones"
            value={obs || "-"}
          />

          <InfoRow
            label="Firma"
            value={
              firma ? (
                <img
                  src={urlFirma}
                  alt="firma"
                  className="max-w-[10rem]"
                />
              ) : (
                "-"
              )
            }
          />
        </div>

        <div className={sectionClass}>
          <SectionTitle>USUARIO</SectionTitle>

          <InfoRow
            label="Apellido y nombres"
            value={User?.nombreCompleto || "-"}
          />

          <InfoRow
            label="DNI"
            value={User?.dni || "-"}
          />
        </div>

        <Button
          variant="primary"
          fullWidth
          onClick={closeVerEgreso}
          className="h-[45px]"
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
}

export default VerEgresoComponent;